// eslint-disable-next-line
import React, { Fragment } from "react";
import "./App.css";

function convertToSlug(Text) {
  return Text.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}

function getSplitLength(categories) {
  let total = 0
  let length = 0
  let skip = false
  for (let i = 0; i < categories.length; i += 1) {
    total += categories[i].items.length + 4
  }
  const itemLength = total > 0 ? Math.round(total / 2) : 0
  total = 0
  for (let i = 0; i < categories.length; i += 1) {
    total += categories[i].items.length + 4
    if (total > itemLength && !skip) {
      length = i + 1
      skip = true
    }
  }
  return length
}

const Mobilemenu = ({
  businessName,
  categories = [],
  grid_view,
  ItemTextColor,
  ItemPriceColor,
  descriptionColor,
  categoryColor,
  websiteTextColor,
  hideMenuPrice,
}) => {
  const spicy = `${window.location.origin}/assets/img/spicy.png`
  const hot = `${window.location.origin}/assets/img/hot.png`
  const extreme = `${window.location.origin}/assets/img/extreme.png`
  const text_color = ItemTextColor || websiteTextColor
  const price_color = ItemPriceColor || websiteTextColor
  const desc_color = descriptionColor || websiteTextColor
  const cat_color = categoryColor || websiteTextColor
  const catLength = categories?.length > 0 ? getSplitLength(categories) : 0
  return (
    <div className="section section-padding menu-v2 menu-center-align">
      {(!hideMenuPrice || grid_view) &&
        <div className="container">
          {categories?.map((category, index) => (
            <Fragment key={index}>
              {(grid_view || !category.image) && (
                <div className="grid-title">
                  <h3 style={{ color: cat_color }}>{category?.online_name ? category?.online_name : category?.name}</h3>
                  <p style={{ color: cat_color }}>{category?.description}</p>
                </div>
              )}
              {!grid_view && category.image && (
                <div
                  className="menu-category dark-overlay dark-overlay-2"
                  style={{
                    backgroundImage: `url(${category.image})`,
                  }}
                >
                  <h3 style={{ color: cat_color }}>{category?.online_name ? category?.online_name : category?.name}</h3>
                  <p style={{ color: cat_color }}>{category?.description}</p>
                </div>
              )}
              <div className="row">
                {grid_view ? (
                  <>
                    {categories[index].items.map((item, i) => (
                      <div key={i} className="col-lg-4">
                        <div className="ct-mini-menu-item">
                          <div className="grid-image">
                            <img className="grid-image-style" src={item.image || `/assets/img/plate.svg`} alt="" />
                          </div>
                          <div style={{ display: 'flex', paddingTop: '5px' }}>
                            <h5 style={{ fontSize: '15px', margin: '0 0 0 5px', width: '100%', color: text_color }}>
                              {item?.online_name ? item?.online_name : item?.name}
                            </h5>
                            {!hideMenuPrice &&
                              <span style={{ margin: '0 5px 0 0', textAlign: 'right', color: price_color }}>
                                ${((item.price) / 100).toFixed(2)}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {categories[index].items.map((item, i) => (
                      <>
                        <div key={i} className="col-lg-6">
                          <div className="ct-mini-menu-item">
                            <div className="ct-mini-menu-top">
                              <h5 style={{ color: text_color }}>
                                {item?.online_name ? item?.online_name : item?.name}
                              </h5>
                              {businessName === "ELEVATED PIZZA CO" ? (<div className="ct-mini-menu-without-dots" />) : (<div className="ct-mini-menu-dots" />)}
                              <span className="custom-primary" style={{ color: price_color }}>
                                ${((item.price) / 100).toFixed(2)}
                              </span>
                            </div>
                            <div className="ct-mini-menu-bottom" style={{ color: desc_color }}>
                              <p style={{ color: desc_color }}>{item.description}</p>
                              {item?.tags?.map((tag) => (
                                <span className={`tag-label tag-${convertToSlug(tag)}`}>{tag}</span>
                              ))}
                              {item?.spice_level === 1 &&
                                <span><img src={spicy} width="15" alt="Spicy" title="Spicy" /></span>
                              }
                              {item?.spice_level === 2 &&
                                <span><img src={hot} width="25" alt="Very Spicy" title="Very Spicy" /></span>
                              }
                              {item?.spice_level === 3 &&
                                <span><img src={extreme} width="30" alt="Extreme Spicy" title="Extreme Spicy" /></span>
                              }
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </>
                )}
              </div>
            </Fragment>
          ))}
        </div>
      }
      {hideMenuPrice && !grid_view &&
        <div className="container image-center-align menu-section-body">
          <div className="row">
            <div className="col-lg-6">
              {categories?.slice(0, catLength)?.map((category, index) => (
                <div key={index} className="menu-section">
                  <div className="grid-title">
                    <h3 style={{ color: cat_color }}>{category?.online_name ? category?.online_name : category?.name}</h3>
                  </div>
                  <ul>
                    {category.items.map((item, i) => (
                      <li key={`item-${i}`} className="menu-sub-item">
                        <div className="menu-sub-item-heading">
                          <p style={{ color: text_color }}>{item?.online_name ? item?.online_name : item?.name}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="col-lg-6">
              {categories?.slice(catLength)?.map((category, index) => (
                <div key={index} className="menu-section">
                  <div className="grid-title">
                    <h3 style={{ color: cat_color }}>{category?.online_name ? category?.online_name : category?.name}</h3>
                  </div>
                  <ul>
                    {category.items.map((item, i) => (
                      <li key={`item-${i}`} className="menu-sub-item">
                        <div className="menu-sub-item-heading">
                          <p style={{ color: text_color }}>{item?.online_name ? item?.online_name : item?.name}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Mobilemenu;
